export default class AdPlaceholder {
    selectors = {
        kevel: '.kevel-ad-placeholder',
        kevelBannerTop: '.kevel-banner-top',
        pbContext: 'pbContext',
        osanoLink: 'head link[href*="osano.js"]',
    };

    elements = {
        kevel: null,
        kevelBannerTop: null,
        pbContext: null,
        osanoLink: null,
    };

    variables = {
        data: {},
        pbContext: '',
        osanoLink: '',
    };

    constructor() {
        this.setElements();
        this.addEventListeners();
        this.renderKevel();
    }

    setElements() {
        this.elements.kevel = UX.utils.convertToArray(document.querySelectorAll(this.selectors.kevel));
        this.elements.kevelBannerTop = document.querySelector(this.selectors.kevelBannerTop);
        this.elements.pbContext = document.getElementsByName(this.selectors.pbContext)[0];
        this.elements.osanoLink = document.querySelector(this.selectors.osanoLink);
    }

    addEventListeners() {
        window.addEventListener('resize', () => {
            this.hideKevelPlaceholder();
        });
    }

    renderKevel() {
        if (this.elements.kevel.length) {
            this.setKevelData();
            this.elements.kevel.forEach(item => {
                this.variables.data['kevel-widget-ids'] = [item.getAttribute('data-placeholder-widget-id')];
                this.getKevelPlaceholder(item);
            });
        }
    }

    setKevelData() {
        this.variables.osanoLink = this.elements.osanoLink?.href;
        this.variables.pbContext = encodeURIComponent(this.elements.pbContext?.content);
        this.variables.data = {
            'viewport-width': window.innerWidth,
            'kevel-widget-ids': [],
        };
    }

    getKevelPlaceholder(kevelPlaceholder) {
        fetch(`/pb/widgets/kevel-ad-placeholder/get-kevel-ads-content?pbContext=${this.variables.pbContext}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.variables.data),
        })
            .then(response => response.json())
            .then(result => {
                if (result['kevel-widgets-data'].length) {
                    // Handle the API response here
                    const ad = result['kevel-widgets-data'][0];
                    const iframe = document.createElement('iframe');
                    // 20 and 16 are the margin total for the body tag within the iframe
                    iframe.width = parseInt(ad.width) + 16;
                    iframe.height = parseInt(ad.height) + 20;

                    if (ad.html) {
                        const isOsanoIncluded = ad.html.includes('osano.js');
                        iframe.srcdoc = isOsanoIncluded ? ad.html : this.getOsanoScripts() + ad.html;
                    }

                    kevelPlaceholder.append(iframe);
                    iframe.onload = function () {
                        if (iframe.contentDocument && iframe.contentDocument.documentElement) {
                            iframe.contentDocument.documentElement.style.overflow = 'hidden';
                        }
                        kevelPlaceholder.removeAttribute('hidden');
                    };
                } else {
                    // Handle the empty response
                    console.log('INFO: No Kevel ads suitable to this page'); // eslint-disable-line no-console
                }
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error in loading Kevel ads, for the following reason:', error); // eslint-disable-line no-console
            });
    }

    hideKevelPlaceholder() {
        const isSmallScreen = window.innerWidth < UX.grid.screenSm;
        if (this.elements.kevelBannerTop) {
            this.elements.kevelBannerTop.hidden = isSmallScreen;
        }
    }

    getOsanoScripts() {
        return `
            <!-- WOL: adding Osano to ad frame -->
            <link rel="preload" href="${this.variables.osanoLink}" as="script">
            <script src="${this.variables.osanoLink}"></script>
            <style>.osano-cm-widget, .osano-cm-dialog { display:none; }</style>
            <script>
                window.Osano.cm.addEventListener("osano-cm-script-blocked", function (item) {
                    console.log("Script blocked: " + item);
                });
                window.Osano.cm.addEventListener("osano-cm-cookie-blocked", function (item) {
                    console.log("Cookie blocked: " + item);
                });
            </script>
        `;
    }
}
